import { Component, Input, Renderer2 } from '@angular/core';
import {
  AttributeValue,
  FormTypes,
} from '../../../../../models/section-definition.model';

@Component({
  selector: 'lib-attribute-value-row',
  standalone: false,
  templateUrl: './attribute-value-row.component.html',
  styleUrls: ['./attribute-value-row.component.scss'],
})
export class AttributeValueRowComponent {
  @Input() attributeValue!: AttributeValue;
  FormTypes = FormTypes;

  getDateFormat(attr: any): string {
    if (attr.is24HourFormat == null) {
      return 'dd/MM/yyyy';
    }
    return attr.is24HourFormat ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy hh:mm a';
  }

  getRenderType(type: string): string {
    const enumValue = FormTypes[type as keyof typeof FormTypes];

    if ([FormTypes.Text, FormTypes.TextDescription].includes(enumValue)) {
      return 'string';
    }
    if (enumValue === FormTypes.Number) return 'number';
    if (enumValue === FormTypes.DateTime) return 'date';
    if (enumValue === FormTypes.Bool) return 'bool';
    return 'default';
  }
}
